module.exports = __webpack_public_path__ + "img/trans_caderneta.e9ecf357.png";